import React from 'react';

class ContactLinks extends React.PureComponent {
  render() {
    return (
      <div className="contact-links">
        <span>
          <a rel="noopener" target="_blank" href="mailto:tkdev.to@gmail.com">
            Email
          </a>
        </span>
        <span>
          <a
            rel="noopener"
            target="_blank"
            href="https://www.linkedin.com/in/tonykwak"
          >
            LinkedIn
          </a>
        </span>
        <span>
          <a rel="noopener" target="_blank" href="https://github.com/digital-fellow-io">
            GitHub
          </a>
        </span>
      </div>
    );
  }
}

export default ContactLinks;



// WEBPACK FOOTER //
// ./src/components/ContactLinks.js